export const buildConfig={date:"Wed Feb 26 19:00:47 GMT 2025"}
